const baseUrl = process.env.VUE_APP_BASEURL;
import WebSocketService from '@/utils/WebSocketService';
export default {
    data() {
        return {
            webSocketService: null,
            message: null,
        };
    },
    computed: {
        userId() {
            return this.$store.state.userId;
        }
    },
    mounted() {
        //初始化WebSocket
        this.initWebSocket();
    },
    watch:{
        userId(newValue,oldValue){
            console.log("watch userId",newValue,oldValue)
            this.initWebSocket();
        }
    },
    methods: {
        initWebSocket(url=baseUrl+"/ws") {
            // 放在header中没生效,通过拼接路径参数
            const header = {
                'Sec-WebSocket-Protocol': this.$store.state.token
            }
            // console.log("socket header",header)
            if(!this.$store.state.userId){
                console.log("userId is null ,! register ")
                return;
            }
            // 初始化 WebSocket 连接
            this.webSocketService = new WebSocketService();
            this.webSocketService.connect(header,url+`?token=${this.$store.state.token}`,this.$store.state.userId, this.onMessage);
        },
        closeWebSocket() {
            // 关闭 WebSocket 连接
            if (this.webSocketService) {
                this.webSocketService.disconnect();
            }
        },
        // 处理接收到的消息
        onMessage(message) {
            console.log('Received message:', message)
            this.message = message;
        },
        // 发送消息到 WebSocket 服务器
        sendMessage(message) {
            if (message) {
                this.webSocketService.sendMessage(message);
            }
        },
    },
    beforeDestroy() {
        console.log("beforeDestroy closeWebSocket")
        this.closeWebSocket();
    },
};
